<template>

<div>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Configurações de Registro</h4>
    </div>
    <div class="card-content">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <p class="category">
              Exibir campo de <strong>profissão</strong>?
            </p>
            <p-radio
              inline
              v-model="project.register.carrer"
              label="true"
            >Sim
            </p-radio>
            <p-radio
              inline
              v-model="project.register.carrer"
              label="false"
            >Não
            </p-radio>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LampsConfigForm',
  computed: {
    ...mapGetters('project', { modelValidations: 'validations' }),
    project: {
      get () {
        return this.$store.state.project.one
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Project/RegisterConfigForm.vue